<div id="jumperContainer">
  @if (prefix.length) {
    <span class="text">{{ prefix }}</span>
  }
  <mat-form-field appearance="fill">
    <input [value]="currentItemIndex.toString()"
      matInput
      #itemIndexInput
      type="number">
    </mat-form-field>
    <span class="text">of {{ numberOfItems }}</span>
    @if (showSideArrows) {
      <div id="sideArrowsContainer">
        <button mat-icon-button (click)="previous()" [disabled]="!currentItemIndex || currentItemIndex === 1">
          <mat-icon svgIcon="chevron_up"></mat-icon>
        </button>
        <button mat-icon-button (click)="next()" [disabled]="currentItemIndex === numberOfItems">
          <mat-icon svgIcon="chevron_down"></mat-icon>
        </button>
      </div>
    }
  </div>
